import * as z from "zod";

export const generateCommerceCloudImportFiles = {
  name: "generateCommerceCloudImportFiles" as const,
  input: z.object({
    productId: z.string().min(1),
    catalogId: z.string().min(1),
    currency: z.string().length(3),
    pricebookId: z.string().min(1),
    inventoryListId: z.string().min(1).nullish(),
    categoryId: z.string().min(1).nullish(),
    taxClassId: z.string().min(1).nullish(),
    imagePath: z.string().min(1).nullish(),
    customAttributes: z.record(z.string(), z.string()).nullish(),
    legacyMasterProductId: z.string().min(1).nullish(),
  }),
  output: z.object({
    files: z.array(z.object({ name: z.string(), content: z.string() })),
  }),
};
